export default __webpack_public_path__ + "static/media/join_community_parent.39d5c661.png";